<template>
  <simple-page class="h-100 p-relative bg-wood">
    <div class="anchored scrollable">
      <b-row class="m-0 p-0 mt-3">
        <!--
        <b-card class="border-primary p-4 col-md-4">
          <b-card-title>{{ $t("menu.genericRequests") }}</b-card-title>
        </b-card>
        -->
        <template v-for="(item, index) in menu">
          <router-link
            v-if="item.show === undefined || $resolveFn(item.show)"
            :key="index"
            :to="item.to"
            class="col-md-4 mx-auto mb-3"
          >
            <b-card class="rounded-lg p-4 text-center" :class="item.class">
              <b-card-title>{{ $t(item.label) }}</b-card-title>
            </b-card>
          </router-link>
        </template>
        <!--
        <b-card class="border-primary p-4 col-md-4">
          <b-card-title>{{ $t("menu.loanRequests") }}</b-card-title>
        </b-card>
        <b-card class="border-primary p-4 col-md-4">
          <b-card-title>{{ $t("menu.loanRequests") }}</b-card-title>
        </b-card>
        <b-card class="border-primary p-4 col-md-4">
          <b-card-title>{{ $t("menu.loanRequests") }}</b-card-title>
        </b-card>
        -->
      </b-row>
    </div>
  </simple-page>
</template>
<script>
import lowerFirst from "lodash/lowerFirst";
import BasePageMixin from "vue-template/common/mixins/BasePageMixin";

export default {
  mixins: [BasePageMixin],

  props: {
    menu: {
      type: Array,
      required: true
    }
  },

  mounted() {
    this.$emit("breadcrumbs", this.breadcrumbs());
  },

  methods: {
    breadcrumbs() {
      const routeName = this.$route.name;

      return [
        {
          icon: "home",
          text: "Home",
          to: "/protected"
        },
        {
          text: () => this.$t("menu." + lowerFirst(routeName))
        }
      ];
    }
  }
};
</script>
